parcelRequire = function(e, r, t, n) {
    var i, o = "function" == typeof parcelRequire && parcelRequire, u = "function" == typeof require && undefined;
    function f(t, n) {
        if (!r[t]) {
            if (!e[t]) {
                var i = "function" == typeof parcelRequire && parcelRequire;
                if (!n && i) return i(t, !0);
                if (o) return o(t, !0);
                if (u && "string" == typeof t) return u(t);
                var c = new Error("Cannot find module '" + t + "'");
                throw c.code = "MODULE_NOT_FOUND", c;
            }
            p.resolve = function(r) {
                return e[t][1][r] || r;
            }, p.cache = {};
            var l = r[t] = new f.Module(t);
            e[t][0].call(l.exports, p, l, l.exports, this);
        }
        return r[t].exports;
        function p(e) {
            return f(p.resolve(e));
        }
    }
    f.isParcelRequire = !0, f.Module = function(e) {
        this.id = e, this.bundle = f, this.exports = {};
    }, f.modules = e, f.cache = r, f.parent = o, f.register = function(r, t) {
        e[r] = [
            function(e, r) {
                r.exports = t;
            },
            {}
        ];
    };
    for(var c = 0; c < t.length; c++)try {
        f(t[c]);
    } catch (e) {
        i || (i = e);
    }
    if (t.length) {
        var l = f(t[t.length - 1]);
        "object" == typeof exports && "undefined" != typeof module ? module.exports = l : "function" == typeof define && define.amd ? define(function() {
            return l;
        }) : n && (this[n] = l);
    }
    if (parcelRequire = f, i) throw i;
    return f;
}({
    iucA: [
        function(require1, module1, exports1) {},
        {
            "./DINNextLTW23-Medium.eot": [
                [
                    "DINNextLTW23-Medium.c0b60f7f.eot",
                    "AW13"
                ],
                "AW13"
            ],
            "./DINNextLTW23-Medium.woff2": [
                [
                    "DINNextLTW23-Medium.abe52636.woff2",
                    "wZYS"
                ],
                "wZYS"
            ],
            "./DINNextLTW23-Medium.woff": [
                [
                    "DINNextLTW23-Medium.7ea804a1.woff",
                    "gxb7"
                ],
                "gxb7"
            ],
            "./DINNextLTW23-Medium.ttf": [
                [
                    "DINNextLTW23-Medium.1a8a401d.ttf",
                    "XYtz"
                ],
                "XYtz"
            ],
            "./DINNextLTW23-Medium.svg": [
                [
                    "DINNextLTW23-Medium.9bdc9b68.svg",
                    "atu0"
                ],
                "atu0"
            ],
            "./DINNextLTW23-Light.eot": [
                [
                    "DINNextLTW23-Light.0d2eecdc.eot",
                    "oruh"
                ],
                "oruh"
            ],
            "./DINNextLTW23-Light.woff2": [
                [
                    "DINNextLTW23-Light.a4429561.woff2",
                    "bXSE"
                ],
                "bXSE"
            ],
            "./DINNextLTW23-Light.woff": [
                [
                    "DINNextLTW23-Light.a0f7fdb4.woff",
                    "MU3p"
                ],
                "MU3p"
            ],
            "./DINNextLTW23-Light.ttf": [
                [
                    "DINNextLTW23-Light.0e459486.ttf",
                    "S1pJ"
                ],
                "S1pJ"
            ],
            "./DINNextLTW23-Light.svg": [
                [
                    "DINNextLTW23-Light.e298dc9e.svg",
                    "UZJi"
                ],
                "UZJi"
            ]
        }
    ],
    D9Nj: [
        function(require1, module1, exports1) {},
        {}
    ],
    H99C: [
        function(require1, module1, exports1) {
            "use strict";
            require1("./fonts/fonts.css"), require1("./styles.css");
            var e = function(e, t) {
                var n = {
                    1: 1034,
                    5: 1035,
                    10: 1036,
                    20: 1037,
                    50: 1038
                };
                return {
                    init: function() {
                        document.addEventListener("click", function() {
                            var e, t;
                            (t = document.createElement("a")).href = "sms:".concat(n[e], "?&body=Meal"), t.click();
                        });
                    }
                };
            }();
        },
        {
            "./fonts/fonts.css": "iucA",
            "./styles.css": "D9Nj"
        }
    ]
}, {}, [
    "H99C"
], null); //# sourceMappingURL=/src.f5761dcd.js.map

//# sourceMappingURL=index.baa4a0df.js.map
